
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jiklhmgbcydpfnokmkih.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imppa2xobWdiY3lkcGZub2tta2loIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg4MDM1MjYsImV4cCI6MjA2NDM3OTUyNn0.1peyNFPQXjuxiXzb-UtcRL14dtBw0a06F8gy0rb2azo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

// Helper function for cleaning up auth state (placeholder for future implementation)
export const cleanupAuthState = () => {
  // This function can be used to clean up auth state when needed
  // Implementation will be added when auth tables are created
  console.log('Auth state cleanup called');
};
